module.exports = __webpack_public_path__ + "img/IMG_6945.a94b47ad.webp";